import { Link } from "react-router-dom";
import analyticsImg from "../../assets/illustrations/dashboard-analytics.png";

export default function Inicio() {
  return (
    <div className="container-fluid py-4 text-dark">
      {/* MIGAS */}
      <ol className="breadcrumb float-xl-end">
        <li className="breadcrumb-item">
          <Link to="/devioz/dashboard">Dashboard</Link>
        </li>
        <li className="breadcrumb-item active">Inicio</li>
      </ol>

      <h1 className="page-header mb-3 fw-bold">Inicio</h1>

      {/* PORTADA */}
      <div className="card border-0 mb-4 shadow-sm">
        <div className="card-body d-flex flex-column flex-lg-row align-items-center justify-content-between gap-3">
          <div>
            <h2 className="fw-bold mb-2">Bienvenido a <span className="text-primary">Devioz</span></h2>
            <p className="text-muted mb-3">
              Plataforma de Ingesta de Datos y Dashboard Empresarial para la gestión inteligente
              de información de <strong>BCP, Bembos, Claro, PlazaVea y Gloria</strong>.
            </p>
            <Link to="/devioz/dashboard" className="btn btn-primary">
              Ir al Dashboard
            </Link>
          </div>
          <img
            src={analyticsImg}
            alt="Ilustración Devioz"
            height={160}
            style={{ objectFit: "contain" }}
          />
        </div>
      </div>

      {/* SECCIÓN DE CARDS */}
      <div className="row">
        {/* EMPRESAS ACTIVAS */}
        <div className="col-xl-4 col-md-6">
          <div className="card border-0 mb-3 shadow-sm">
            <div className="card-body">
              <b className="d-block mb-2">Empresas activas</b>
              <ul className="list-unstyled mb-0">
                {["BCP", "Bembos", "Claro", "PlazaVea", "Gloria"].map((e) => (
                  <li key={e} className="d-flex justify-content-between align-items-center border-bottom py-1">
                    <span>{e}</span>
                    <span className="badge bg-primary-subtle text-primary fw-semibold">Operativa</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* DATOS GENERALES */}
        <div className="col-xl-4 col-md-6">
          <div className="card border-0 mb-3 shadow-sm">
            <div className="card-body">
              <b className="d-block mb-2">Datos generales</b>
              <div className="d-flex flex-column gap-2">
                <div className="d-flex justify-content-between">
                  <span>Total de datasets</span>
                  <span className="fw-bold">5</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>Última actualización</span>
                  <span className="fw-bold">03/11/2025</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>Versión del sistema</span>
                  <span className="fw-bold">v2.1.0</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ACCESOS RÁPIDOS */}
        <div className="col-xl-4 col-md-12">
          <div className="card border-0 mb-3 shadow-sm">
            <div className="card-body">
              <b className="d-block mb-2">Accesos rápidos</b>
              <div className="d-flex flex-column gap-2">
                <Link to="/devioz/empresas" className="btn btn-outline-primary w-100">
                  Ver empresas
                </Link>
                <Link to="/devioz/usuarios" className="btn btn-outline-primary w-100">
                  Gestión de usuarios
                </Link>
                <Link to="/devioz/roles" className="btn btn-outline-primary w-100">
                  Configurar roles
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <div className="text-center text-muted small mt-4">
        © 2025 Devioz — Plataforma Empresarial Inteligente
      </div>
    </div>
  );
}
